import {
    LOGIN_SIG,
    LOGIN_SIG_FAIL,
    LOGIN_SIG_SUCCESS
} from './types'
import axios from 'axios'
import api from './api';
import { setCookie, ab2str, deleteCookie } from '../utils'

export const logar_signatario = (dados, callback) => {
    return dispatch => {
        dispatch({ type: LOGIN_SIG })
        localStorage.clear()

        api.post('signatario/auth', dados)
            .then( async res => {
            res = res.data            

            setCookie('assinaturaSignatario', true,4)
            
            localStorage.setItem('user', JSON.stringify(dados))
            //localStorage.setItem('signatario',JSON.stringify(res.payload.signatario))
            
            //transforma o arrayBuffer em string e salva 
            var reader = new window.FileReader();
            var img;

            const documento = res.payload.url ? res.payload.url : res.payload.base64pdf
            localStorage.setItem('documento', JSON.stringify(documento))
            //reader.readAsDataURL(res); 
            
            // reader.onload = await async function() {
            //   var imageDataUrl = await reader.result;
            //   localStorage.setItem('documento', JSON.stringify(res.payload))
            //   if(callback)
            //     callback()
            // }
            localStorage.setItem('signatario',JSON.stringify({dados}))
            localStorage.setItem('historico',JSON.stringify({
                historico: res.payload.historico,
                infosDoc: res.payload.documento,
                signatario: res.payload.signatarios
            }))

            localStorage.setItem('exigencia', JSON.stringify({
                selfie: res.payload.selfie === 'S',
            }))
          
            dispatch({ 
                type: LOGIN_SIG_SUCCESS, 
                payload: res,
                message:'', 
                historico: res.payload.historico || [] 
            })

            if(callback)
                callback()
 
        }).catch( err => {
            var msg = 'Erro! Tente novamente mais tarde.'
            if(err.response != undefined ) 
                msg = err.response.data.message
            else if(err.message != undefined) 
                msg = err.message
            dispatch({ type: LOGIN_SIG_FAIL, payload: msg})
        })

    }
}

export const deslogar = () => {
    localStorage.removeItem('documento')
    localStorage.removeItem('signatario')
    localStorage.removeItem('user')
    deleteCookie('assinaturaSignatario')
    window.location.href = '/auth'
}